const getters = {
    token: state => state.user.token,
    avatar: state => state.user.avatar,
    username: state => state.user.username,
    auth: state => state.user.auth,
    userType: state => state.user.userType
}
export default getters